import * as token from "@universityofmaryland/web-token-library";
import { handleKeyboardNavigation } from "@universityofmaryland/web-utilities-library/events";
import { close_large } from "@universityofmaryland/web-icons-library/controls";
import { createCompositeNavigationSlider } from "../slider/index.js";
const ANIMATION_TIME = 300;
const ELEMENT_NAV_DRAWER_CONTAINER = "nav-drawer-container";
const ELEMENT_NAV_DRAWER_OVERLAY = "nav-drawer-overlay";
const ELEMENT_NAV_DRAWER_OVERLAY_WRAPPER = "nav-drawer-overlay-wrapper";
const ELEMENT_NAV_DRAWER_CLOSE_BUTTON = "nav-drawer-close-button";
const DrawerButtonClose = `
  .${ELEMENT_NAV_DRAWER_CLOSE_BUTTON} {
    background-color: ${token.color.red};
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${token.spacing["2xl"]};
    width: ${token.spacing["2xl"]};
    padding: 12px;
    transition: background .5s ease-in-out;
    order: 2;
  }

  .${ELEMENT_NAV_DRAWER_CLOSE_BUTTON}:hover,
  .${ELEMENT_NAV_DRAWER_CLOSE_BUTTON}:focus {
    background-color: ${token.color.redDark};
  }

  .${ELEMENT_NAV_DRAWER_CLOSE_BUTTON} svg {
    fill: ${token.color.white};
  }
`;
const DrawerContainer = `
  .${ELEMENT_NAV_DRAWER_CONTAINER} {
    position: fixed;
    bottom: 0;
    left: 0;
    top: 0;
    display: none;
    z-index: 999999;
  }

  .${ELEMENT_NAV_DRAWER_OVERLAY} {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0,0,0,0.5);
    transition: opacity ${ANIMATION_TIME}ms ease-in-out;
    cursor: pointer;
    opacity: 0;
  }

  .${ELEMENT_NAV_DRAWER_OVERLAY_WRAPPER} {
    display: flex;
    height: 100%;
    transition: transform ${ANIMATION_TIME + 100}ms ease-in-out;
    transform: translateX(-100%);
  }

  .${ELEMENT_NAV_DRAWER_OVERLAY_WRAPPER} > *:not(.${ELEMENT_NAV_DRAWER_CLOSE_BUTTON}) {
    height: 100% !important;
  }
`;
const STYLES_NAV_DRAWER_ELEMENT = `
  ${createCompositeNavigationSlider.Styles}
  ${DrawerButtonClose}
  ${DrawerContainer}
`;
const CreateDrawerButton = (element) => {
  const drawerCloseButton = document.createElement("button");
  drawerCloseButton.innerHTML = close_large;
  drawerCloseButton.classList.add(ELEMENT_NAV_DRAWER_CLOSE_BUTTON);
  drawerCloseButton.setAttribute("aria-label", "Close navigation drawer");
  drawerCloseButton.addEventListener("click", element.eventClose.bind(element));
  return drawerCloseButton;
};
const CreateNavDrawerContainer = (props) => {
  const { eventClose } = props;
  const bodyOverlay = document.createElement("div");
  const bodyOverlayWrapper = document.createElement("div");
  const closeButton = CreateDrawerButton(props);
  const slider = createCompositeNavigationSlider.CreateElement({
    ...props,
    displayType: "drawer-nav"
  });
  bodyOverlayWrapper.classList.add(ELEMENT_NAV_DRAWER_OVERLAY_WRAPPER);
  bodyOverlayWrapper.appendChild(closeButton);
  bodyOverlayWrapper.appendChild(slider.container);
  bodyOverlay.classList.add(ELEMENT_NAV_DRAWER_OVERLAY);
  bodyOverlay.addEventListener("click", eventClose.bind(props));
  bodyOverlay.appendChild(bodyOverlayWrapper);
  return bodyOverlay;
};
const CreateNavDrawerElement = (props) => (() => {
  const { context, primarySlideLinks } = props;
  const body = document.querySelector("body");
  const elementContainer = document.createElement("div");
  if (!primarySlideLinks) return null;
  const eventClose = () => {
    const bodyOverlay = elementContainer.querySelector(
      `.${ELEMENT_NAV_DRAWER_OVERLAY}`
    );
    const bodyOverlayWrapper = bodyOverlay.querySelector(
      `.${ELEMENT_NAV_DRAWER_OVERLAY_WRAPPER}`
    );
    const slider = bodyOverlay.querySelector(
      `.${createCompositeNavigationSlider.Elements.slider}`
    );
    bodyOverlay.style.opacity = "0";
    bodyOverlayWrapper.style.transform = "translateX(-100%)";
    setTimeout(() => {
      bodyOverlay.removeAttribute("style");
      bodyOverlayWrapper.removeAttribute("style");
      body.style.overflow = "auto";
      elementContainer.style.display = "none";
    }, ANIMATION_TIME + 100);
    if (slider) {
      slider.style.overflowY = `hidden`;
    }
  };
  const eventOpen = () => {
    const bodyOverlay = elementContainer.querySelector(
      `.${ELEMENT_NAV_DRAWER_OVERLAY}`
    );
    const bodyOverlayWrapper = bodyOverlay.querySelector(
      `.${ELEMENT_NAV_DRAWER_OVERLAY_WRAPPER}`
    );
    const closeButton = bodyOverlayWrapper.querySelector(
      `.${ELEMENT_NAV_DRAWER_CLOSE_BUTTON}`
    );
    const slider = bodyOverlayWrapper.querySelector(
      `.${createCompositeNavigationSlider.Elements.slider}`
    );
    const activeSlide = bodyOverlayWrapper.querySelector(
      `.${createCompositeNavigationSlider.Elements.slider} div[data-active]`
    );
    elementContainer.style.display = "block";
    bodyOverlay.style.display = "block";
    bodyOverlayWrapper.style.display = "flex";
    setTimeout(() => {
      bodyOverlay.style.opacity = "1";
      bodyOverlayWrapper.style.transform = "translateX(0)";
      body.style.overflow = "hidden";
      closeButton.focus();
      handleKeyboardNavigation({
        element: elementContainer,
        action: () => eventClose(),
        shadowDomContext: context
      });
    }, 100);
    setTimeout(() => {
      if (!activeSlide || !slider) return;
      if (activeSlide.offsetHeight > elementContainer.offsetHeight) {
        slider.style.overflowY = `scroll`;
      }
    }, 200);
  };
  const children = CreateNavDrawerContainer({
    ...props,
    eventOpen,
    eventClose
  });
  elementContainer.classList.add(ELEMENT_NAV_DRAWER_CONTAINER);
  elementContainer.appendChild(children);
  return {
    element: elementContainer,
    events: {
      eventOpen
    }
  };
})();
const createCompositeNavigationDrawer = {
  CreateElement: CreateNavDrawerElement,
  Styles: STYLES_NAV_DRAWER_ELEMENT
};
export {
  createCompositeNavigationDrawer
};
//# sourceMappingURL=index.js.map
